import { PrintProviderType } from '../types/common.types';

export const defaultPrintSettings: PrintProviderType['drawingPrintSettings'] = {
  defaultFormatGroup: null,
  formatGroups: [],
  defaultPrintOption: null,
  printOptions: [],
  defaultPostProcessingOption: null,
  postProcessingOptions: []
};

export const defaultProviderData: PrintProviderType = {
  printProviderId: '',
  isEnabled: true,
  country: 'se',
  name: '',
  decription: '',
  address: '',
  phoneNumber: '',
  email: '',
  website: '',
  orderingSystems: [],
  omsUsers: [],
  omsType: 'Standard',
  omsServiceUrl: '',
  omsSecretKey: '',
  drawingPrintSettings: defaultPrintSettings,
  documentPrintSettings: defaultPrintSettings,
  deliveryOptions: {
    standardDeliveryMinDays: null,
    standardDeliveryMaxDays: null,
    expressDeliveryMinHours: null,
    expressDeliveryEnabled: false
  },
  isOrgIdRequired: false,
  language: 'sv',
  emailForOrders: ''
};
